type GetIncentivesMarketHomePathOptions = {
  beneficiaryQuery?: string;
  isBeneficiaryView?: boolean;
};

export const getIncentivesMarketHomePath = (
  societyId: string,
  options: GetIncentivesMarketHomePathOptions = {}
): string => {
  const beneficiaryQuery = options.beneficiaryQuery ?? '';
  const isBeneficiaryView =
    options.isBeneficiaryView ?? Boolean(beneficiaryQuery);

  if (isBeneficiaryView) {
    return `/ofertas-incentivos/${societyId}${beneficiaryQuery}`;
  }

  return `/mercado-de-incentivos/${societyId}${beneficiaryQuery}`;
};
